import React, { useState, useEffect } from "react";
import { connect } from 'react-redux';
import '../../Styles/reset.css'
import '../../Styles/Main.css'
import HeaderBar from '../Menu/HeaderBar'
import Container from './Container';
import {  MessageBar, MessageBarType, Modal, } from "@fluentui/react";
import Layout from "../../Styles/Layout";
import URL from "../../Containers/MainController";
import Type from "../../Redux/Type";
import DrawingToolBar from "../Drawing/ControlBar";
import Statistical from "../Drawing/Statistical";
import { store } from "../../Redux/Store";
import { onLoadMenu as loadMenuQuyHoach } from "../../Containers/QuyHoach";
import setup from "../../Containers/setup";
import LoginNew from "../../Components/Profile/LoginNew";
import PageLoading from "../../Components/Profile/PageLoading";
import { useSelector } from "react-redux";
import { onInfoByToken } from "../../Containers/LoginEnter";

const Main = (props) => {
    const [message] = useState('');
    const [isLoadding, setIslodding] = useState(false);
    const userInfoEnter = useSelector(state => state.UserInfoEnter);
    let tokenEnterPrise = localStorage.getItem(URL.tokenEnterPrise)
    useEffect(() => {
        document.title = setup.title;
        onSetLoginStateAtStart();
    })

    const onSetLoginStateAtStart = () => {
        if (tokenEnterPrise && !userInfoEnter && !isLoadding) {
            setIslodding(true)
            let onGetInfo = ({ statusCode, response }) => {
                setIslodding(false)
            };
            onInfoByToken(tokenEnterPrise, onGetInfo);
            
        }
        if(userInfoEnter && userInfoEnter.APILink){
            loadMenuQuyHoach(userInfoEnter.APILink);
        }
    };

    const onCloseModal = () => props.dispatch({ type: Type.SET_SHOW_MAIN_MODAL })

    if (isLoadding) {
        return (
            <PageLoading />
        )
    } else {
        if (!userInfoEnter) {
            return (<LoginNew />)
        } else {
            return (
                <section className='position-absolute' style={styles.container}>
                    <Container />
                    <HeaderBar />
                    <DrawingToolBar />
                    {message ?
                        <MessageBar
                            messageBarType={MessageBarType.blocked}
                            isMultiline={true}
                            onDismiss={() => store.dispatch({ type: Type.SET_MAIN_MESSAGE, message: '' })}
                            truncated={true}
                            dismissButtonAriaLabel="Đóng"
                            styles={styles.messageBar}
                        >
                            {message}
                        </MessageBar>
                        : undefined
                    }
                    <Modal
                        isOpen={props.showModal}
                        onDismiss={onCloseModal}
                        isBlocking={false}
                        dragOptions={null}
                    >
                        <Statistical />
                    </Modal>
                </section>
            )
        }
    }
}

const mapStateToProps = (state) => ({
    showModal: state.mapView.showModal,
    message: state.mainAlertMessage,
    userInfo: state.userInfo
});

export default connect(mapStateToProps)(Main);

const styles = {
    container: {
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        backgroundColor: '#fff'
    },
    messageBar: {
        root: {
            position: 'absolute',
            top: 48,
            right: 0,
            width: Layout.warningMessage,
            backgroundColor: '#FDE7E9'
        }
    },
    modalContainer: {
        display: 'flex',
        width: 300
    }
};

